export default __webpack_public_path__ + "static/media/encryption_logo.42c71235.webp";